import { GlobalSettings } from 'EstraSponsor'

export const globalSettings: GlobalSettings = {
  facebookUrl: 'https://www.facebook.com/EstraSpa',
  instagramUrl: 'https://www.instagram.com/estra_spa/',
  linkedinUrl: 'https://www.linkedin.com/company/estra-spa',
  efUrl: 'https://www.estra.it/ef-magazine/indice/tutti',
  appAndroidUrl:
    'https://play.google.com/store/apps/details?id=it.estraspa.areaclienti&hl=it',
  appIosUrl: 'https://apps.apple.com/it/app/.estra./id614615236?mt=8',
}
